<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  videoId: string
  class?: HTMLAttributes['class']
}>()

const isPlaying = ref(false)

const playVideo = () => {
  isPlaying.value = true
}
</script>
<template>
  <div
    :class="
      cn(
        'relative w-full h-full max-lg:aspect-video overflow-hidden rounded-xl bg-background',
        props.class
      )
    "
  >
    <button
      v-if="!isPlaying"
      class="relative w-full h-full block cursor-pointer group"
      aria-label="Play video"
      @click="playVideo"
    >
      <img
        :src="`https://img.youtube.com/vi/${props.videoId}/maxresdefault.jpg`"
        alt="Video thumbnail"
        class="w-full top-1/2 -translate-y-1/2 absolute object-cover"
      />
      <!-- Play button overlay -->
      <div
        class="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors"
      >
        <div class="rounded-full p-1 shadow-xl bg-on-error">
          <Icon
            name="material-symbols:play-circle"
            size="64px"
            class="text-error"
          />
        </div>
      </div>
    </button>
    <iframe
      v-else
      style="height: 100%; width: 100%"
      height="100%"
      width="100%"
      :src="`https://www.youtube.com/embed/${props.videoId}?autoplay=1&controls=1`"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  </div>
</template>
